import React from 'react';
import { FaGem, FaShippingFast, FaShieldAlt } from 'react-icons/fa';
import RevealOnScroll from './RevealOnScroll';

const WhyUs = () => (
    <section id="why-us" className="why-us-section">
        <div className="container">
            <RevealOnScroll>
                <h2>Why Partner with StoneCore</h2>
            </RevealOnScroll>
            <div className="features-grid">
                <RevealOnScroll>
                    <div className="feature-item">
                        <FaGem className="feature-icon" />
                        <h4>Superior Quality</h4>
                        <p>Our rigorous quality control ensures product consistency and performance for every project.</p>
                    </div>
                </RevealOnScroll>
                <RevealOnScroll>
                    <div className="feature-item">
                        <FaShippingFast className="feature-icon" />
                        <h4>Reliable Delivery</h4>
                        <p>With a robust logistics network, we guarantee on-time delivery to your site, every time.</p>
                    </div>
                </RevealOnScroll>
                <RevealOnScroll>
                    <div className="feature-item">
                        <FaShieldAlt className="feature-icon" />
                        <h4>Sustainable Practices</h4>
                        <p>We are committed to environmentally responsible mining and land reclamation.</p>
                    </div>
                </RevealOnScroll>
            </div>
        </div>
    </section>
);

export default WhyUs;